export default __webpack_public_path__ + "static/media/me.55763841.png";